export default __webpack_public_path__ + "static/media/closet5-before2-1440w.e1a336c8.avif";